module.exports = __webpack_public_path__ + "img/9_82.1758660a.png";